import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const DATE_VALUES = {
  month: 1000 * 60 * 60 * 24 * 30,
  year: 1000 * 60 * 60 * 24 * 365,
};

export const startOfDay = (date: Date): Date => {
  return dayjs(date).startOf('day').toDate();
};

export const endOfDay = (date: Date): Date => {
  return dayjs(date).endOf('day').toDate();
};

export const parsePaymentDate = (dateString: string): Date | null => {
  if (!dateString) return null;

  const dateWithTime = dayjs(dateString, 'DD.MM.YYYY HH:mm:ss', true);
  if (dateWithTime.isValid()) {
    return dateWithTime.toDate();
  }

  const dateWithoutTime = dayjs(dateString, 'DD.MM.YYYY', true);
  if (dateWithoutTime.isValid()) {
    return dateWithoutTime.toDate();
  }

  const fallback = new Date(dateString);
  return isNaN(fallback.getTime()) ? null : fallback;
};

export const formatDateTimeUTC = (timestamp: number) => {
  const date = new Date(timestamp);

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC',
  }).format(date);
};
